import React from 'react';
import 'antd/dist/antd.css';
import { Tag, Input, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

class InputTag extends React.Component {
  state = {
    tags: this.props.value || [],
    inputVisible: false,
    inputValue: '',
    editInputIndex: -1,
    editInputValue: '',
  };

  componentWillReceiveProps(nextProps) {
    const { value } = this.props;
    if (nextProps.value !== value) {
      this.setState({
        tags: nextProps.value
      })
    }
  }

  handleClose = removedTag => {
    const { onChange } = this.props;
    const tags = this.state.tags.filter(tag => tag !== removedTag);
    onChange(tags)
    this.setState({ tags });
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    let value = e.target.value;
    if (this.props.onlyNumbersAndSpecial) {
      value = value.replace(/[a-zA-Z\u00C0-\u00FF\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF]/g, '');
    }
    this.setState({ inputValue: value });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    const { onChange } = this.props;
    let { tags } = this.state;
    const trimmedValue = inputValue ? inputValue.trim() : '';
    if (trimmedValue && tags.indexOf(trimmedValue) === -1) {
      tags = [...tags, trimmedValue];
    }
    onChange(tags)
    this.setState({
      tags,
      inputVisible: false,
      inputValue: '',
    });
  };

  handleEditInputChange = e => {
    let value = e.target.value;
    if (this.props.onlyNumbersAndSpecial) {
      value = value.replace(/[a-zA-Z\u00C0-\u00FF\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF]/g, '');
    }
    this.setState({ editInputValue: value });
  };

  handleEditInputConfirm = () => {
    const { onChange } = this.props;
    this.setState(({ tags, editInputIndex, editInputValue }) => {
      const newTags = [...tags];
      const trimmedValue = editInputValue ? editInputValue.trim() : '';
      newTags[editInputIndex] = trimmedValue;
      onChange(newTags)
      return {
        tags: newTags,
        editInputIndex: -1,
        editInputValue: '',
      };
    });
  };

  saveInputRef = input => {
    this.input = input;
  };

  saveEditInputRef = input => {
    this.editInput = input;
  };

  render() {
    const { tags, inputVisible, inputValue, editInputIndex, editInputValue } = this.state;
    const { disabled, nameAdd, disabledTag, numberTag, containerStyle, validateTag } = this.props;
    const hasError = tags && validateTag && tags.some(tag => !validateTag(tag));

    return (
      <div style={{ width: "96%", margin: '4px 0 3px 10px', ...containerStyle }}>
        {tags && tags.length > 0 && tags.map((tag, index) => {
          if (editInputIndex === index) {
            return (
              <Input
                ref={this.saveEditInputRef}
                key={tag}
                size="small"
                style={{ width: '130px', marginRight: '8px', verticalAlign: 'top' }}
                value={editInputValue}
                onChange={this.handleEditInputChange}
                onBlur={this.handleEditInputConfirm}
                onPressEnter={this.handleEditInputConfirm}
              />
            );
          }

          const isValid = validateTag ? validateTag(tag) : true;
          const isLongTag = tag.length > 20;

          const tagElem = (
            <Tag
              style={{
                userSelect: 'none',
                marginBottom: "3px",
                ...(!isValid ? { border: '1px solid #ff4d4f', color: '#ff4d4f' } : {})
              }}
              key={tag}
              closable={!disabled}
              onClose={() => this.handleClose(tag)}
            >
              <span
                onDoubleClick={e => {
                  if (!disabled) {
                    this.setState({ editInputIndex: index, editInputValue: tag }, () => {
                      this.editInput.focus();
                    });
                    e.preventDefault();
                  }
                }}
              >
                {isLongTag ? `${tag.slice(0, 20)}...` : tag}
              </span>
            </Tag>
          );
          return isLongTag ? (
            <Tooltip title={tag} key={tag}>
              {tagElem}
            </Tooltip>
          ) : (
            tagElem
          );
        })}
        {inputVisible && (
          <Input
            ref={this.saveInputRef}
            type="text"
            size="small"
            style={{ width: '130px', marginRight: '8px', verticalAlign: 'top' }}
            value={inputValue}
            onChange={this.handleInputChange}
            onBlur={this.handleInputConfirm}
            onPressEnter={this.handleInputConfirm}
          />
        )}
        {!inputVisible && !disabled && !disabledTag && tags?.length < numberTag && (
          <Tag
            style={{
              borderStyle: 'dashed',
              cursor: hasError ? "not-allowed" : "pointer",
              opacity: hasError ? 0.4 : 1,
            }}
            onClick={hasError ? null : this.showInput}
          >
            <PlusOutlined /> {nameAdd}
          </Tag>
        )}
      </div>
    );
  }
}
export default InputTag;